module.exports = __webpack_public_path__ + "img/minus.b4f173a0.svg";